"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _smsConfigApi = require("@/api/smsConfigApi");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var emptyAccount = function emptyAccount(provider) {
  return {
    provider: provider,
    enabled: true,
    accessKeyId: '',
    accessKeySecret: '',
    sdkAppId: '',
    signName: ''
  };
};
var emptyConfig = function emptyConfig() {
  return {
    enabled: true,
    provider: 'TENCENT',
    useGlobal: true,
    tencent: emptyAccount('TENCENT'),
    aliyun: emptyAccount('ALIYUN')
  };
};
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var requiredCurrent = function requiredCurrent(field, message) {
      return {
        validator: function validator(rule, value, callback) {
          if (_this.config.enabled && !_this.config.useGlobal && !_this.currentAccount[field]) callback(new Error(message));else callback();
        },
        trigger: 'blur'
      };
    };
    return {
      visible: false,
      loading: false,
      saving: false,
      testing: false,
      companyAppId: null,
      appName: '',
      config: emptyConfig(),
      globalAccounts: {
        tencent: emptyAccount('TENCENT'),
        aliyun: emptyAccount('ALIYUN')
      },
      testForm: {
        phone: '',
        templateCode: '',
        templateParams: ''
      },
      rules: {
        provider: [{
          required: true,
          message: '请选择短信服务商',
          trigger: 'change'
        }],
        currentAccessKeyId: [requiredCurrent('accessKeyId', '请输入访问密钥ID')],
        currentAccessKeySecret: [requiredCurrent('accessKeySecret', '请输入访问密钥Secret')],
        currentSdkAppId: [requiredCurrent('sdkAppId', '请输入腾讯云SmsSdkAppId')],
        currentSignName: [requiredCurrent('signName', '请输入短信签名')]
      },
      testRules: {
        phone: [{
          required: true,
          message: '请输入测试手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的11位中国大陆手机号',
          trigger: ['blur', 'change']
        }],
        templateCode: [{
          required: true,
          message: '请输入短信模板Code',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    currentAccount: function currentAccount() {
      return this.config.provider === 'TENCENT' ? this.config.tencent : this.config.aliyun;
    },
    displayAccount: function displayAccount() {
      if (!this.config.useGlobal) return this.currentAccount;
      return this.config.provider === 'TENCENT' ? this.globalAccounts.tencent : this.globalAccounts.aliyun;
    }
  },
  methods: {
    open: function open(row) {
      var _this2 = this;
      this.companyAppId = row.id;
      this.appName = row.name || row.appName || '';
      this.config = emptyConfig();
      this.globalAccounts = {
        tencent: emptyAccount('TENCENT'),
        aliyun: emptyAccount('ALIYUN')
      };
      this.testForm = {
        phone: '',
        templateCode: '',
        templateParams: ''
      };
      this.visible = true;
      this.loading = true;
      (0, _smsConfigApi.getCompanyAppSmsConfig)(row.id).then(function (res) {
        var appConfig = res.config || {};
        _this2.config = _objectSpread(_objectSpread(_objectSpread({}, emptyConfig()), appConfig), {}, {
          tencent: _objectSpread(_objectSpread({}, emptyAccount('TENCENT')), appConfig.tencent || {}),
          aliyun: _objectSpread(_objectSpread({}, emptyAccount('ALIYUN')), appConfig.aliyun || {})
        });
        _this2.globalAccounts = {
          tencent: _objectSpread(_objectSpread({}, emptyAccount('TENCENT')), res.globalTencent || {}),
          aliyun: _objectSpread(_objectSpread({}, emptyAccount('ALIYUN')), res.globalAliyun || {})
        };
      }).finally(function () {
        _this2.loading = false;
        _this2.$nextTick(function () {
          if (_this2.$refs.form) _this2.$refs.form.clearValidate();
          if (_this2.$refs.testForm) _this2.$refs.testForm.clearValidate();
        });
      });
    },
    close: function close() {
      this.companyAppId = null;
      this.appName = '';
    },
    handleProviderChange: function handleProviderChange() {
      this.clearConfigValidate();
      this.testForm.templateParams = '';
    },
    clearConfigValidate: function clearConfigValidate() {
      var _this3 = this;
      this.$nextTick(function () {
        return _this3.$refs.form && _this3.$refs.form.clearValidate();
      });
    },
    validateConfig: function validateConfig() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        _this4.$refs.form.validate(function (valid) {
          return valid ? resolve() : reject(new Error('validate failed'));
        });
      });
    },
    persist: function persist() {
      var _this5 = this;
      return this.validateConfig().then(function () {
        _this5.currentAccount.enabled = true;
        _this5.saving = true;
        return (0, _smsConfigApi.saveCompanyAppSmsConfig)(_this5.companyAppId, _this5.config).then(function () {
          _this5.$message.success('小程序短信配置保存成功');
          _this5.$emit('refresh');
        }).finally(function () {
          _this5.saving = false;
        });
      });
    },
    save: function save() {
      var _this6 = this;
      this.persist().then(function () {
        _this6.visible = false;
      }).catch(function () {});
    },
    validateTestParams: function validateTestParams() {
      if (!this.testForm.templateParams) return true;
      try {
        var params = JSON.parse(this.testForm.templateParams);
        var validType = this.config.provider === 'TENCENT' ? Array.isArray(params) : params && _typeof(params) === 'object' && !Array.isArray(params);
        if (!validType) throw new Error('invalid type');
        return true;
      } catch (e) {
        this.$message.warning(this.config.provider === 'TENCENT' ? '腾讯云模板参数必须是 JSON 数组' : '阿里云模板参数必须是 JSON 对象');
        return false;
      }
    },
    sendTest: function sendTest() {
      var _this7 = this;
      if (!this.config.enabled) {
        this.$message.warning('请先开启短信服务');
        return;
      }
      Promise.all([this.validateConfig(), new Promise(function (resolve, reject) {
        _this7.$refs.testForm.validate(function (valid) {
          return valid ? resolve() : reject(new Error('validate failed'));
        });
      })]).then(function () {
        if (!_this7.validateTestParams()) return;
        _this7.testing = true;
        return (0, _smsConfigApi.testSmsSend)(_objectSpread({
          companyAppId: _this7.companyAppId,
          appConfig: _this7.config,
          provider: _this7.config.provider
        }, _this7.testForm)).then(function (res) {
          if (res && res.success) {
            _this7.$message.success('发送成功~');
          } else {
            _this7.$message.error('发送失败，请稍后再试~');
          }
        }).finally(function () {
          _this7.testing = false;
        });
      }).catch(function () {});
    }
  }
};